export default {
    data() {
      return {
        onlyView: false,
        delay: 100,
        clicks: 0,
        timer: null,
        polygonIsInside: false,
        paths: [],
        markers: [
          {
            position: {
              lat: 0,
              lng: 0,
            },
          },
        ],
        google: null,
        map: null,
        isCircular: true,
        circleCenter: {
          lat: 0,
          lng: 0,
        },
        circleRange: 100,
        polygonOptions: {
          editable: true,
          draggable: true,
          strokeColor: "#0099ff",
          fillColor: "#0099ff",
        },
        circleOptions: {
          strokeColor: "#0099ff",
          fillColor: "#0099ff",
        },
      };
    },
    mounted() {
      this.setDefault();
    },
    methods: {
  
  
      reduceOnClick() {
        if (!this.onlyView) {
          this.clicks++;
          if (this.clicks === 1) {
            this.timer = setTimeout(() => {
              this.reducePolygon();
              this.clicks = 0;
            }, this.delay);
          } else {
            clearTimeout(this.timer);
            this.clicks = 0;
          }
        }
      },
      setDefault() {
        let position = [
          {
            position: {
              lat: -33.4283789,
              lng: -70.5407851,
            },
          },
        ];
        let zone = [
          {
            lat: -33.4283789,
            lng: -70.5407851,
            radius: 100,
          },
        ];
        this.setSpot(position, zone);
      },
      viewSpot(spot, zone) {
        this.onlyView = true;
        let position = [
          {
            position: {
              lat: spot.lat,
              lng: spot.lng,
            },
          },
        ];
        this.polygonOptions.draggable = false;
        this.polygonOptions.editable = false;
        this.setSpot(position, zone);
      },
      setSpot(position, zone) {
        this.markers = position;
        this.circleCenter = position[0].position;
        this.setGeoreference(zone);
        this.setMap(position[0].position);
      },
      setGeoreference(zone) {
        this.isCircular = this.checkCircular(zone);
        if (!this.isCircular) {
          if (zone.length < 3 || zone === undefined) {
            this.paths = [];
            this.paths.push({
              lat: this.circleCenter.lat - 0.0002,
              lng: this.circleCenter.lng + 0.0005,
            });
            this.paths.push({
              lat: this.circleCenter.lat - 0.000190703,
              lng: this.circleCenter.lng - 0.000560582,
            });
            this.paths.push({
              lat: this.circleCenter.lat + 0.000546196,
              lng: this.circleCenter.lng + 0.00045206,
            });
          } else {
            let tempPaths = [];
            zone.forEach(function (element) {
              let temp = {
                lat: element.lat,
                lng: element.lon,
              };
              tempPaths.push(temp);
            });
            this.paths = tempPaths;
          }
        } else {
          if (zone === undefined) {
            this.circleRange = 100;
          } else {
            zone[0].radius === undefined
              ? (this.circleRange = zone[0].radio)
              : (this.circleRange = zone[0].radius);
          }
        }
      },
      reducePolygon() {
        if (this.paths.length > 3) {
          this.paths.splice(-1);
        }
      },
      createGeoreference(isCircular, radius) {
        this.isCircular = isCircular;
        this.circleCenter = this.markers[0].position;
        if (!isCircular) {
          this.paths = [];
          this.paths.push({
            lat: this.circleCenter.lat - 0.0002,
            lng: this.circleCenter.lng + 0.0005,
          });
          this.paths.push({
            lat: this.circleCenter.lat - 0.000190703,
            lng: this.circleCenter.lng - 0.000560582,
          });
          this.paths.push({
            lat: this.circleCenter.lat + 0.000546196,
            lng: this.circleCenter.lng + 0.00045206,
          });
          this.verifyPolygonStatus();
        } else {
          this.paths = [];
          this.circleRange = radius;
        }
      },
      createEditedGeoreference(zone, spot) {
        let position = [
          {
            position: {
              lat: spot.lat,
              lng: spot.lng,
            },
          },
        ];
        this.setSpot(position, zone);
      },
      checkCircular(zone) {
        if (zone === undefined) {
          return true;
        }
        return zone.length <= 1;
      },
      updatePath(mvcArray) {
        this.paths = [];
        for (let i = 0; i < mvcArray.getLength(); i++) {
          for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
            let element = {
              lat: mvcArray.getAt(i).getAt(j).lat(),
              lng: mvcArray.getAt(i).getAt(j).lng(),
            };
            this.paths.push(element);
          }
        }
        this.verifyPolygonStatus();
      },
      verifyPolygonStatus() {
        if (this.checkPolygon()) {
          this.polygonIsInside = true;
          this.polygonOptions.strokeColor = "#0099ff";
          this.polygonOptions.fillColor = "#0099ff";
        } else {
          this.polygonIsInside = false;
          this.polygonOptions.strokeColor = "#ff0019";
          this.polygonOptions.fillColor = "#ff0019";
        }
      },
      checkPolygon() {
        let minX = this.paths[0].lat;
        let maxX = this.paths[0].lat;
        let minY = this.paths[0].lng;
        let maxY = this.paths[0].lng;
        this.paths.forEach(function (element) {
          minX = Math.min(element.lat, minX);
          maxX = Math.max(element.lat, maxX);
          minY = Math.min(element.lng, minY);
          maxY = Math.max(element.lng, maxY);
        });
        if (
          this.markers[0].position.lat < minX ||
          this.markers[0].position.lat > maxX ||
          this.markers[0].position.lng < minY ||
          this.markers[0].position.lng > maxY
        ) {
          return false;
        }
        let isInside = false;
        for (
          var i = 0, j = this.paths.length - 1;
          i < this.paths.length;
          j = i++
        ) {
          if (
            this.paths[i].lng > this.markers[0].position.lng !=
              this.paths[j].lng > this.markers[0].position.lng &&
            this.markers[0].position.lat <
              ((this.paths[j].lat - this.paths[i].lat) *
                (this.markers[0].position.lng - this.paths[i].lng)) /
                (this.paths[j].lng - this.paths[i].lng) +
                this.paths[i].lat
          ) {
            isInside = !isInside;
          }
        }
        return isInside;
      },
      setMap(element) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.panTo(element);
          map.setZoom(16);
        });
      },
    },
  };
  